// removed by extract-text-webpack-plugin
module.exports = {"rexCard":"nULgUMZgtRTf5fZFiQ-Dc","rexBreadcrumb":"_3vzmIESorfWjtJVW5jY8Os"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rex.css
// module id = 224
// module chunks = 0